import { render } from "./AccountExpandableMenu.vue?vue&type=template&id=8245acfa"
import script from "./AccountExpandableMenu.vue?vue&type=script&lang=js"
export * from "./AccountExpandableMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trifjolngjela/Projects/home-budget/home-budget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItemSection,QItemLabel,QChip,QList,QItem,QIcon,QSpace});
